import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@abb/uikit';
import React from 'react';
const DownIcon = (props)=>{
    return /*#__PURE__*/ _jsx(Icon, {
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M7.99999 8.78145L11.3 5.48145L12.2427 6.42411L7.99999 10.6668L3.75732 6.42411L4.69999 5.48145L7.99999 8.78145Z",
            fill: "currentColor"
        })
    });
};
export default DownIcon;
